<template>
   <div class="group-link-report">
    <el-card class="box-card">
       <div slot="header" class="clearfix">
        <span><i class="el-icon-document"></i>Report Monthly fee group link</span>
      </div>
      <div class="search-area">
        <el-form :inline="true" :model="formSearch" class="demo-form-inline">
            <el-form-item label="Group name">
                <el-input v-model="formSearch.group_name" placeholder="Search Group" prefix-icon="el-icon-search"></el-input>
            </el-form-item>
            <el-form-item label="From">
                <el-date-picker v-model="formSearch.from" type="date"  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="To">
                <el-date-picker v-model="formSearch.to" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getReport()">Search</el-button>
                <el-button icon="el-icon-download" type="success" @click="exportExcel()">Export</el-button>
            </el-form-item>
        </el-form>
        </div>
        
     <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading">
      
      <el-table-column prop="created_date" label="Created Date" width="180" fixed="left"></el-table-column>
      <el-table-column prop="group_name" label="Group Name" width="180" fixed="left"></el-table-column>
      <el-table-column prop="monthly_uid" label="Monthly UID" min-width="180"></el-table-column>
      
      <el-table-column label="From Information" header-align="center">
        <el-table-column prop="from_project_name" label="Project Name" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="from_vender" label="Vendor" width="120"></el-table-column>
        <el-table-column prop="from_currency" label="Currency" width="100"></el-table-column>
        <el-table-column prop="from_membercode" label="Member Code" width="120"></el-table-column>
        <el-table-column prop="from_bankholderId" label="Bank Holder ID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="from_prefund_bankholderId" label="Prefund ID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="from_transaction_uid_credit" label="Trans UID Credit" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="from_transaction_uid_debit" label="Trans UID Debit" width="200" show-overflow-tooltip></el-table-column>
      </el-table-column>

      <el-table-column label="To Information" header-align="center" label-class-name="to-info-column-header">
        <el-table-column prop="to_project_name" label="Project Name" width="150" show-overflow-tooltip label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_vender" label="Vendor" width="120" label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_currency" label="Currency" width="100" label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_membercode" label="Member Code" width="120" label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_bankholderId" label="Bank Holder ID" width="150" show-overflow-tooltip label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_prefund_bankholderId" label="Prefund ID" width="150" show-overflow-tooltip label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_transaction_uid_credit" label="Trans UID Credit" width="200" show-overflow-tooltip label-class-name="to-info-column-header"></el-table-column>
        <el-table-column prop="to_transaction_uid_debit" label="Trans UID Debit" width="200" show-overflow-tooltip label-class-name="to-info-column-header"></el-table-column>
      </el-table-column>

      <el-table-column prop="amount" label="Amount" width="120" fixed="right" align="right" label-class-name="to-info-column-header"></el-table-column>
      
    </el-table>
    <el-pagination
      class="pagination-report-fee-group"
      @size-change="setPageSize"
      @current-change="setPage"
      :current-page.sync="pagination.page"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="pagination.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length">
    </el-pagination>
    </el-card>
   </div> 
</template>
<script>
import { getMonthlyfeeGroupReport, getMonthlyfeeGroupReportExport } from '@/api/linkgroup'
export default {
    components: {
        pagedTableData() {
      return this.tableData.slice(
        this.pagination.limit * this.pagination.page - this.pagination.limit,
        this.pagination.limit * this.pagination.page
      );
    },  
    },
    data(){
      return{
        loading: false,
        tableData: [],
        pagination: {
          page: 1,
          limit: 50,
          total: 0
        },
        formSearch:{
          group_name: "",
          from: "",
          to: ""
        }
      }   
    },
    methods:{
      setPage(val) {
      this.pagination.page = val;
    },
    setPageSize(val) {
      this.pagination.limit = val;
    },
      getReport(){
        this.loading = true
        this.tableData = []
        
        getMonthlyfeeGroupReport(this.formSearch).then(({result, data}) => {
          if(result){
            this.tableData = data.rows || data
            this.pagination.total = data.count || data.length || 0
            // Fallback if API doesn't return count/rows structure yet, though it should for pagination
             if (Array.isArray(data)) {
               this.tableData = data
               this.pagination.total = data.length
             }
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      exportExcel(){
        getMonthlyfeeGroupReportExport(this.formSearch, "Monthly fee group link report.xlsx")
      }
    },
    mounted(){
      this.getReport()
    }
}
</script>
<style lang="scss" scoped>
 .group-link-report {
  .search-area {
    margin-bottom: 16px;

    button {
      margin-left: 10px;
      margin-bottom: 16px;
    }
  }
  .pagination-report-fee-group{
    margin-top: 16px;
  }

  ::v-deep .to-info-column-header{
    background-color: #f0f9eb !important;
    color: #67C23A;
  }
}
</style>